import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotifyList from './List';
import NotifyCreate from './Create';
import NotifyDetail from './Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    ResponseRequiredDate: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    StartDate: { visible: false, label: '', required: false },
    EndDate: { visible: false, label: '', required: false },
}
const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    if(clauses && clauses.length > 0) {
        fields.Type = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
        fields.Type.clauses = clauses;
    }
    if (workflowItem.replyEnabled) {
        fields.ResponseRequiredDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.RESPONSE_REQUIRED"], required: false };
    }
    fields.Details = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };
    fields.StartDate = { visible: true, label: languageFile["CONTRACT.WF.DIARY.FIELD.START_DATE"], required: true };
    fields.EndDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.END_DATE"], required: true };

    return fields;
}
///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };
    const workflowItem = workflowsQA[wfid];

    let replyOptions = workflowItem.replyOptions;

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}

class DiaryRouter extends React.Component {
    constructor(props) {
        super(props);

        if (props.mode === 'WEATHER') {
            this.documentType = 'DocumentWeather';
        }
        else if (props.mode === 'SITE_DIARY') {
            this.documentType = 'DocumentDiary';
        }
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<NotifyList
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                        />}
                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <NotifyCreate
                                    {...this.props}
                                    title={this.notificationName}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<NotifyDetail
                            {...this.props}
                            
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            documentType={this.documentType}
                            notifyUserFilter={workflowItem.notifyUserFilter}
                        />}
                    />
                </Routes>
            </>
        );
    }
}

export default (DiaryRouter);